// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 279 ? "component---src-pages-index-jsx" : chunkId) + "-" + {"279":"ff080db12da0cd6ef485","522":"8ae5606744af930b6790"}[chunkId] + ".js";
};